import JSONApiClient from '../jsonapi-service';
import { authService } from '../auth-service';
import AxiosService from '../axios-service';

// TODO Client brief needs adding
export function createCampaign(campaignData, clientOrganisationData) {
  const client = JSONApiClient();

  const campaign = client.create('campaigns');
  campaign.set('name', campaignData.name);
  campaign.set('campaignType', campaignData.campaignType);
  campaign.set('memberCount', 1);
  campaign.set('description', `Description generated at ${(new Date()).toTimeString()}`);
  campaign.set('budget', campaignData.budget);
  campaign.set('clientBrief', 'https://s3-eu-west-1.amazonaws.com/cf-templates-o6s432he4qgr-eu-west-1/2016202Jd5-dyzio-aws-stack.json');
  if (campaignData.liveDate) campaign.set('liveDate', campaignData.liveDate);
  if (clientOrganisationData.hasClient === 'yes') { campaign.set('client', { type: 'organisations', id: clientOrganisationData.id }); }

  return campaign.sync()
    .then(response => response);
}

export function getCampaignOld(campaignId) {
  const client = JSONApiClient();

  return client.get('campaigns', campaignId, { include: ['owner', 'pendingInvitations', 'members'] })
    .then(response => response);
}

// ADD ATTRIBUTES TO CAMPAIGN OBJECT FOR QUERYING
function makeCampaignQuery(campaignId) {
  const query = `
  query Campaign {
    campaigns(id: "${campaignId}") {
      id
      name
      description
      budget
      campaignType
      liveDate
      endDate
      currency
      country
      approvalStatus
      impressionsCPM
      engagementsCPM
      ieRatio
      scanUnauthorisedStories
      useEstimatedReachAndImpressions
      captureAllStories
      captureAllStoriesWhenMatched
      premiumFeaturesBlocked
      isShopifyCampaign
      isPrestaShopCampaign
      workflow
      baseTrackingUrl
      campaignCode
      sendChaseEmails
      hashtags
      brand
      creationStatus
      rollfwdCampaign {
        id
        name
      }
      mailouts{
        name
        id
      }
      discussions {
        id
        name
        budget
        lastScannedDate
        createdDate
        lastSuccessfulStoryScan
        instagramScanFailures
        isScanningCompleted
        internalDiscountCode
        discountCode
        productOrderedDate
        workflowStatus
        hasPosted
        bioLinkUrl
        trackedAssets {
          id
          assetId
          assetURL
          platform
          assetType
          createdBy
          createdDate
          createdSource
          publishedDate
        }
        stories {
          id
          platform
          caption
          assetId
          assetURL
          assetType
          createdDate
          createdBy
          createdSource
          latestReach
          latestImpressions
        }
        organisations {
          id
          name
          orgType
          influencer {
            id
            name
            thumbnail
            email
            facebook
            facebookCount
            facebookAuthorised
            facebookStatus
            instagram
            instagramCount
            instagramVerified
            instagramStatus
            instagramAuthorised
            instagramBusinessAccount
            youtube
            youtubeStatus
            youtubeCount
            twitter
            twitterStatus
            twitterCount
            twitterAuthorised
            youtubeAuthorised
            youtubeCount
            youtubeStatus
            youtubeChannelTitle
            primarySocialHandle
            instagramPrivate
            discountCode
            usageRightsGranted
            tiktok
            instagramId
            tiktokId
            tiktokCount
            telegramChannels {
              username
            }
            twitch
          }
        }
        invitations {
          id
          status
          link
          metadata
        }
      }
      owner {
        id
        name
      }
      shortlist {
        id
        name
      }
      partnerAgency {
        id
        name
      }
      memberCount
      members {
        id
        name
        email
        campaign {
          id
        }
        organisation {
          id
          name
        }
        role
        metadata
        sendDailyNotifications
        sendWeeklyNotifications
      }
      pendingInvitations {
        id
        email
        name
        campaign {
          id
        }
        role
        organisation {
          id
          name
        }
        status
        metadata
      }
      createdDate
      createdBy
    }
  }
  `;
  return query;
}

// ADD ATTRIBUTES TO CAMPAIGN OBJECT FOR QUERYING
function makeFastLoadCampaignQuery(campaignId) {
  const query = `
  query FastLoadCampaign {
    campaigns(id: "${campaignId}") {
      id
      name
      description
      budget
      campaignType
      liveDate
      endDate
      currency
      country
      approvalStatus
      impressionsCPM
      engagementsCPM
      ieRatio
      scanUnauthorisedStories
      useEstimatedReachAndImpressions
      premiumFeaturesBlocked
      isShopifyCampaign
      isPrestaShopCampaign
      workflow
      baseTrackingUrl
      campaignCode
      sendChaseEmails
      hashtags
      brand
      creationStatus
      captureAllStories
      rollfwdCampaign {
        id
        name
      }
      discussions {
        id
        name
        budget
        lastScannedDate
        lastSuccessfulStoryScan
        instagramScanFailures
        isScanningCompleted
        internalDiscountCode
        discountCode
        productOrderedDate
        workflowStatus
        hasPosted
        createdDate
        bioLinkUrl
        influencer {
          id
          name
          thumbnail
          email
          facebook
          facebookCount
          facebookAuthorised
          facebookStatus
          instagram
          instagramCount
          instagramVerified
          instagramStatus
          instagramAuthorised
          instagramBusinessAccount
          youtube
          youtubeStatus
          youtubeCount
          twitter
          twitterStatus
          twitterCount
          twitterAuthorised
          youtubeAuthorised
          youtubeCount
          youtubeStatus
          youtubeChannelTitle
          primarySocialHandle
          instagramPrivate
          usageRightsGranted
          discountCode
          tiktok
          tiktokCount
          instagramId
          tiktokId
          telegramChannels {
            username
          }
          twitch
        }
        trackedAssets{
          id
        }
        stories {
          id
        }
      }
      owner {
        id
        name
      }
      shortlist {
        id
        name
      }
      partnerAgency {
        id
        name
      }
      memberCount
      createdDate
      createdBy
    }
  }
  `;
  return query;
}

export function getCampaign(campaignId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 20000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = makeCampaignQuery(campaignId);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
    .then(response => response.data.data.campaigns[0]);
}

export function getFastLoadCampaign(campaignId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 20000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = makeFastLoadCampaignQuery(campaignId);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
    .then(response => response.data.data.campaigns[0]);
}
export function getCampaignMembers(campaignId) {
  const client = JSONApiClient();

  return client.get('campaigns', campaignId, { include: ['members'] })
    .then((response, error) =>
      // Returns resource object
      response);
}

function makeCampaignDiscussionQuery(campaignId) {
  const query = `
  query CampaignDiscussions {
    campaigns(id: "${campaignId}") {
      id
      currency
      hashtags
      discussions {
        id
        name
        budget
        budgetStatus
        discussionType
        trackedAssets {
          id
          assetId
          assetURL
          platform
          assetType
          createdBy
          createdDate
          createdSource
          publishedDate
        }
        stories {
          id
          platform
          caption
          assetId
          assetURL
          assetType
          createdDate
          createdBy
          createdSource
          latestReach
          latestImpressions
        }
        organisations {
          id
          name
          influencer {
            id
            name
            email
            totalSocialReach
            youtubeCount
            facebookCount
            twitterCount
            instagramCount
            primarySocialHandle
            youtubeChannelTitle
            thumbnail
            facebook
            twitter
            instagram
            youtube
            instagramVerified
            twitterVerified
            facebookVerified
            instagramAuthorised
            twitterAuthorised
            facebookAuthorised
            youtubeAuthorised
            instagramStatus
            twitterStatus
            facebookStatus
            youtubeStatus
            instagramBusinessAccount
          }
        }
        invitations {
          id
          status
          link
          metadata
        }
        channelURL
        currentBrief
        members {
          id
          name
          role
        }
        documents {
          id
          name
          filePath
          docType
          fileType
          size
          discussion {
            id
          }
          message
          approved
          createdBy
          createdDate
          approvedBy
          approvalDate
          version
        }
        deliverables {
          id
          title
          channelType
          assetType
          dueDate
          liveDateEnd
          live
          description
          createdBy
          createdDate
          document {
            id
            name
            approved
            version
          }
          documents {
            id
            name
            approved
            version
          }
        }
        trackedAssets {
          id
          assetId
          assetURL
          platform
          assetType
          createdBy
          createdDate
          createdSource
          publishedDate
          supportingData {
            id
            filePath
            engagements
            impressions
            saves
            reach
            createdBy
            createdDate
          }
        }
        currentContract
        signedContract
      }
    }
  }
  `;
  return query;
}

export function getCampaignDiscussions(campaignId) {
  console.log(`looking for ${campaignId}`);
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = makeCampaignDiscussionQuery(campaignId);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
    .then(response => {
      console.log(response);
      return response.data.data.campaigns[0].discussions;
    });
}

function makeScheduleDeliverablesQuery(campaignId) {
  const query = `
  query ScheduleDeliverables {
    campaigns(id: "${campaignId}") {
      id
      name
      discussions {
        id
        name
        members {
          id
          name
          role
        }
        deliverables {
          id
          title
          channelType
          assetType
          dueDate
          liveDateEnd
          live
          description
          createdBy
          createdDate
          document {
            id
            name
            approved
            docType
            filePath
            message
            createdDate
            createdBy
            removed
            approvedBy
            approvalDate
            version
          }
          documents {
            id
            name
            approved
            docType
            filePath
            message
            createdDate
            createdBy
            removed
            approvedBy
            approvalDate
            version
          }
          version
        }
      }
    }
  }
  `;
  return query;
}

export function getScheduleDeliverables(campaignId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = makeScheduleDeliverablesQuery(campaignId);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
    .then(response => response.data.data.campaigns[0]);
}

export function updateCampaign(id, budget) {
  const client = JSONApiClient();
  return client.get('campaigns', id)
    .then(campaign => {
      if (budget) campaign.set('budget', budget);
      return campaign.sync();
    });
}

export function getCampaignDiscussionsOld(campaignId) {
  const client = JSONApiClient();

  return client.get('campaigns', campaignId, { include: ['discussions'] })
    .then(response => {
      // Returns JSON object
      const campaign = response.toJSONTree();
      return campaign.discussions;
    });
}

export function getCampaignPermissions(userId) {
  console.log('getCampaignPermissions');
  const client = JSONApiClient();
  const options = {
    filter: {
      user: userId,
    },
    include: ['campaign'],
    sort: ['-createdDate'],
  };

  return client.find('campaignPermission', options)
    .then(permissions => {
      const campaignPermissions = [];
      permissions.forEach(permission => {
        campaignPermissions.push(permission.toJSONTree());
      });
      // Returns JSON object
      return campaignPermissions;
    });
}

export function removeCampaignPermissionFromCampaign(campaignId, campaignPermission) {
  const client = JSONApiClient();

  client.get('campaigns', campaignId, {})
    .then(campaign => {
      campaign.relationships('members').remove(campaignPermission);
      return campaign.sync()
        .then(campaign => campaign);
    });
}

export function removePendingInviationFromCampaign(campaignId, campaignInvitation) {
  // TODO Requires it's own client to not have circular issues which needs addressing
  const client = JSONApiClient();

  client.get('campaigns', campaignId, {})
    .then(campaign => {
      campaign.relationships('pendingInvitations').remove(campaignInvitation);
      return campaign.sync()
        .then(campaign => campaign);
    });
}

export function addDiscussionToCampaign(campaignId, discussion) {
  const client = JSONApiClient();

  client.get('campaigns', campaignId, {})
    .then(campaign => {
      campaign.relationships('discussions').add(discussion);
      return campaign.sync()
        .then(campaign => campaign);
    });
}

export function addCampaignPermission(campaignResource, campaignPermission) {
  campaignResource.relationships('members').add(campaignPermission);
  return campaignResource.sync()
    .then(response => response);
}

// This doesn't sync the data but instead only preps the resource for syncing.
export function addChatDiscussionToCamapign(campaignResource, discussionName, discussionResource) {
  campaignResource.relationships('discussions').add(discussionResource);
  campaignResource.set(discussionName, discussionResource.toJSON().id);
}

function makeCampaignTrackedAssetsQuery(campaignId) {
  const query = `
  query CampaignTrackedAssets {
    campaigns(id: "${campaignId}") {
      id
      name
      trackedAssets {
        id
        assetId
        assetURL
        platform
        assetType
        createdSource
        createdBy
        createdDate
        user {
          id
        }
        campaign {
          id
          name
        }
        discussion {
          id
          name
        }
      }
      discussions {
        id
        name
        trackedAssets {
          id
          assetId
          assetURL
          platform
          assetType
          createdSource
          createdBy
          createdDate
          user {
            id
          }
          campaign {
            id
            name
          }
          discussion {
            id
            name
          }
        }
      }
    }
  }`;
  return query;
}

export function getCampaignTrackedAssets(campaignId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = makeCampaignTrackedAssetsQuery(campaignId);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
    .then(response => {
      const campaign = response.data.data.campaigns[0];
      const trackedAssetsList = [];
      if (campaign.trackedAssets && campaign.trackedAssets[0]) {
        campaign.trackedAssets.forEach(trackedAsset => trackedAssetsList.push(trackedAsset));
      }
      campaign.discussions.forEach(discussion => {
        if (discussion.trackedAssets && discussion.trackedAssets[0]) {
          discussion.trackedAssets.forEach(trackedAsset => trackedAssetsList.push(trackedAsset));
        }
      });
      return trackedAssetsList;
    });
}

export function updateCampaignTrackedAssets(campaignId, trackedAsset) {
  const client = JSONApiClient();

  return client.get('campaigns', campaignId, {}).then(campaign => {
    campaign.relationships('trackedAssets').add(trackedAsset);
    return campaign.sync();
  });
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/campaigns2.js
 **/